export const options = [
  {
    name: 'Unlimited Load Views',
    expandContent: 'Remove the 5 daily load view limitation and get unlimited access to all loads.',
    essential: true,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Days to Pay&Credit Score',
    expandContent: 'Greater trust and transparency with your broker or shipper.',
    essential: true,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Live Load Updates',
    expandContent: 'See new load postings in real-time and be the first to move that load.',
    essential: true,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Ad Free',
    expandContent: 'Enjoy an ad free experience.',
    essential: true,
    preferred: true,
    ultimate: true,
  },
  {
    name: "Driving Time",
    expandContent:
      'Know your driving time for the trip of loads you are interested in.',
    essential: false,
    preferred: true,
    ultimate: true,
  },
  {
    name: '30 Day Rate Check',
    expandContent:
      "Find out the market price/mile for the lanes you're hauling. Improve your negotiation position.",
    essential: false,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Fuel Surcharge Calculator',
    expandContent: 'Calculate your costs associated with each load, know your actual profit.',
    essential: false,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Live Loads Alert',
    expandContent: 'Get real-time alerts for loads that match your requirements.',
    essential: false,
    preferred: true,
    ultimate: true,
  },
  {
    name: 'Bid Visibility',
    expandContent: 'See view count and bid prices from other carriers.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
  {
    name: 'Round Trip',
    expandContent: 'View outbound and return loads in a single page.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
  {
    name: 'Capacity Ratio',
    expandContent:
      'See the actual inbound and outbound load volume per state, so you know where capacity is tight and where you can make more money.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
  {
    name: '1,7,15 Day Rate check',
    expandContent:
      'Get even more accurate price/mile data on your lanes, down to a 1-7-15 day window.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
  {
    name: 'Historical Trend',
    expandContent: 'Check the past trend for lanes you are interested.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
  {
    name: 'Capacity Indicator',
    expandContent: 'Show the market power of your origin and  destination cities.',
    essential: false,
    preferred: false,
    ultimate: true,
  },
];



// WEBPACK FOOTER //
// ./src/pages/MembershipPlans/utils.js